import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

// actions
import { reversePlacesOrder } from '../../reducers/Places/actions';

// components
import Btn from '../../components/Btn';

// actions
import { fetchDirections } from '../../reducers/Directions/actions';

// helpers
import PlaceUtils from '../../lib/PlaceUtils';

const ReverseBtnPropTypes = {
  dispatchReversePlacesOrder: PropTypes.func.isRequired, // Handles reversing the fields and pins
  fields: PropTypes.arrayOf(PropTypes.object).isRequired, // Array of objects containing information about each "place"
  isMobile: PropTypes.bool.isRequired, // Is this a mobile device
  directionsLoaded: PropTypes.bool.isRequired, // If the directions have successfully returned from service
};

const ReverseBtnDefaultProps = {};

class ReverseBtn extends Component {
  constructor(props) {
    super(props);

    this.swapOriginAndDestination = this.swapOriginAndDestination.bind(this);
  }

  swapOriginAndDestination() {
    const { fields, dispatchReversePlacesOrder } = this.props;
    dispatchReversePlacesOrder(fields[0], fields[1]);
  }

  renderButton() {
    const { fields, isMobile, directionsLoaded } = this.props;

    if (PlaceUtils.oneFieldHasData(fields) && fields.length <= 2) {
      return (
        <Btn
          styles={classNames('reverse-btn', {
            'reverse-btn--mobile': isMobile && directionsLoaded,
            hidden: directionsLoaded,
          })}
          handleClick={this.swapOriginAndDestination}
        >
          <i className="tsla-icon_map--arrow_up_down" />
        </Btn>
      );
    }

    return null;
  }

  render() {
    return this.renderButton();
  }
}

ReverseBtn.propTypes = ReverseBtnPropTypes;

ReverseBtn.defaultProps = ReverseBtnDefaultProps;

const mapStateToProps = state => ({
  fields: state.Places.fields,
  isMobile: state.App.isMobile,
  directionsLoaded: state.Directions.directionsLoaded,
});

const mapDispatchToProps = dispatch => ({
  dispatchReversePlacesOrder: (origin, destination) => {
    dispatch(reversePlacesOrder(origin, destination));
  },
  dispatchFetchDirections: (fields, vehicle) => {
    dispatch(fetchDirections(fields, vehicle));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReverseBtn);
